// import moment from 'moment';
// import axios from 'axios';
// import { MAP_KEY } from 'common/constant/constants';

const MAP_KEY = '67ebb6110ffa104ad36f0147cee30120';
// import { fetchDrivingTracks, fetchRouteNodes } from '../../../api';
// const MAP_KEY = '67ebb6110ffa104ad36f0147cee30120';
const MAP_STYLE = 'amap://styles/whitesmoke';
const carImg = require('../../../assets/images/mapmakers/fongpai_car.png');
const planLocationImg = require('../../../assets/images/mapmakers/dw_plan.png');
const actualLocationImg = require('../../../assets/images/mapmakers/dw_actual.png');

// 异步加载地图
const reqJs = () => new Promise((resolve, reject) => {
  if (!window.AMap) {
    const script = document.createElement('script');
    document.body.appendChild(script);
    script.onload = () => {
      resolve(window.AMap);
    };
    script.onerror = reject;
    script.src = `https://webapi.amap.com/maps?v=1.4.12&key=${MAP_KEY}`;
  } else {
    resolve(window.AMap);
  }
});

// 判断地图是否加载完成
// const hasMapInit = () => !!window.AMap;

// const marker = {};
let markers = [];
// const currentMarkers = [];
// const infoWindow = {};

class GMAP {
  constructor() {
    // 地图原型对象
    this.class_map = null;
    // 地图实例
    this.map = null;
    // placeSearch 实例
    // this.placeSearch = null;
    // autoComplete 的监听事件
    // this.placeSearchListener = null;
    // this.placeSearchListenerList = null;
    // 地址限定的城市
    // this.city = '';
    // 输入的地址名
    // this.name = '';
  }

  /**
   * 初始化地图
   * name: 容器名称
   * mapVue：应用的vue实例
   * source[0], target[0]: lng；source[1], target[1]: lat
   */
  init(name = 'map', data, mapVue) {
    return reqJs()
      .then((AMap) => {
        let source = [];
        let target = [];
        let center = [];
        if (name === 'mapWhole') {
          if (data.nodes && data.nodes.start && data.nodes.start.lng && data.nodes.start.lat) {
            source = [data.nodes.start.lng, data.nodes.start.lat];
            center = [data.nodes.start.lng, data.nodes.start.lat];
          }
          if (data.nodes && data.nodes.end && data.nodes.end.lng && data.nodes.end.lat) {
            target = [data.nodes.end.lng, data.nodes.end.lat];
          }
        }

        if (name === 'mapPop') {
          if (data.distance && JSON.parse(data.distance.plan).length) {
            center = JSON.parse(data.distance.plan).reverse();
          }
        }
        this.class_map = AMap;
        this.map = new AMap.Map(name, {
          resizeEnable: true,
          mapStyle: MAP_STYLE,
          zoom: 9, // 初始化地图层级
          center: center && center.length ? center : [116.397428, 39.90923], // 初始化地图中心点
        });

        AMap.plugin(['AMap.ToolBar'], () => {
          const toolPlugin = new AMap.ToolBar({
            liteStyle: true,
            // position: 'LT',
            offset: AMap.Pixel(10, 10),
          });
          this.map.addControl(toolPlugin);
        });

        if (name === 'mapWhole') {
          let startMarker = null;
          if (source && source.length) {
            // 创建一个 Icon
            const startIcon = new AMap.Icon({
              // 图标尺寸
              size: new AMap.Size(25, 34),
              // 图标的取图地址
              image: '//a.amap.com/jsapi_demos/static/demo-center/icons/dir-marker.png',
              // 图标所用图片大小
              imageSize: new AMap.Size(135, 40),
              // 图标取图偏移量
              imageOffset: new AMap.Pixel(-9, -3),
            });
            // 将 icon 传入 marker
            startMarker = new AMap.Marker({
              position: new AMap.LngLat(source[0], source[1]),
              icon: startIcon,
              offset: new AMap.Pixel(-13, -30),
            });
          }

          let endMarker = null;
          if (target && target.length) {
            // 创建一个 icon
            const endIcon = new AMap.Icon({
              size: new AMap.Size(25, 34),
              image: '//a.amap.com/jsapi_demos/static/demo-center/icons/dir-marker.png',
              imageSize: new AMap.Size(135, 40),
              imageOffset: new AMap.Pixel(-95, -3),
            });

            // 将 icon 传入 marker
            endMarker = new AMap.Marker({
              position: new AMap.LngLat(target[0], target[1]),
              icon: endIcon,
              offset: new AMap.Pixel(-13, -30),
            });
          }

          // 途经点makers
          const viaPoints = [];
          if (data.nodes && data.nodes.points && data.nodes.points.length) {
            data.nodes.points.forEach((via) => {
              const viaIcon = new AMap.CircleMarker({
                center: new AMap.LngLat(via.lng, via.lat),
                radius: 5, // 3D视图下，CircleMarker半径不要超过64px
                strokeColor: '#28F',
                strokeWeight: 2,
                strokeOpacity: 0.5,
                fillColor: '#fff',
                fillOpacity: 1,
                zIndex: 999,
                bubble: true,
                cursor: 'pointer',
                clickable: true,
              });
              viaIcon.on('click', () => {
                mapVue.activeNodeIndex = via.node_index;
                mapVue.detailVisible = true;
              });
              viaPoints.push(viaIcon);
            });
          }

          // 将 markers 添加到地图
          markers = [startMarker, endMarker, ...viaPoints].filter(item => !!item).slice(0, 18);
          markers.length && this.map.add(markers);

          // 车辆当前位置（y:lng, x:lat）
          const makeIcon = (y, x, currentLocation) => {
            const setCurrentMarker = (marker, y, x) => {
              let rotateDeg = 0;
              // 判断区间
              const sectionJudge = (source, target) => {
                const x1 = source[0];
                const y1 = source[1];
                const x2 = target[0];
                const y2 = target[1];
                if (x2 > x1 && y2 >= y1) {
                  return 1;
                } if (x2 >= x1 && y2 < y1) {
                  return 2;
                } if (x2 < x1 && y2 <= y1) {
                  return 3;
                } if (x2 <= x1 && y2 > y1) {
                  return 4;
                }
                return 5;
              };

              if (currentLocation.direction) {
                rotateDeg = currentLocation.direction;
              } else if (target && target.length) {
                // 当前位置作为计算起点
                const source = [y, x];
                const disX = Math.abs(Number(target[0]) - Number(source[0]));
                const dixY = Math.abs(Number(target[1]) - Number(source[1]));
                const tan = Math.tan(dixY / disX);
                const result = Math.atan(tan) / (Math.PI / 180);
                rotateDeg = Math.round(result);
                const section = sectionJudge(source, target);
                if (section === 1) {
                  rotateDeg = 90 - rotateDeg;
                } else if (section === 2) {
                  rotateDeg = 90 + rotateDeg;
                } else if (section === 3) {
                  rotateDeg = 180 + (90 - rotateDeg);
                } else if (section === 4) {
                  rotateDeg = 270 + rotateDeg;
                }
              }

              // 自定义点标记内容
              const markerContent = document.createElement('div');

              // 点标记中的图标
              const markerImg = document.createElement('img');
              markerImg.className = 'currentMaker';
              markerImg.src = carImg;
              markerImg.width = 25;
              markerImg.style.transform = `rotate(${rotateDeg}deg)`;
              markerContent.appendChild(markerImg);
              marker.setContent(markerContent); // 更新点标记内容
              marker.setPosition([y, x]); // 更新点标记位置
            };


            let currentMarker = null;
            if (x && y) {
              currentMarker = new AMap.Marker({
                position: new AMap.LngLat(y, x),
                // icon: currentIcon,
                imageOffset: new AMap.Pixel(-13, -30),
              });
              setCurrentMarker(currentMarker, y, x);
            }
            return currentMarker;
          };


          // 实际路线
          if (mapVue && mapVue.actualLineShow) {
            if (data.track) {
              const tracks = data.track.track || [];
              const currentLocation = data.track.last_point || null;
              const lineArr = [];
              if (tracks.length) {
                tracks.forEach((lineItem) => {
                  if (lineItem && lineItem.ypos && lineItem.xpos) {
                    lineArr.push([lineItem.ypos, lineItem.xpos]);
                  }
                });
                const driverLine = new AMap.Polyline({
                  map: this.map,
                  path: lineArr,
                  showDir: true,
                  strokeColor: '#28F', // 线颜色
                  strokeWeight: 6, // 线宽
                  strokeOpacity: 1,
                  zIndex: 999,
                  lineJoin: 'round',
                });
                this.map.setFitView([driverLine]);
              }

              if (currentLocation) {
                const currentMaker = makeIcon(currentLocation.ypos, currentLocation.xpos, currentLocation);
                const currentCard = data.track.card_info;
                if (mapVue.order_state === 1) {
                  currentMaker.setLabel({
                    offset: new AMap.Pixel(20, 20),
                    content: `<div class='current-info'>
                      <div style='margin-bottom:10px;font-size:14px'>${currentCard.text_for_wb}</div>
                      <div>${currentCard.time} <button id='refreshBtn'>刷新</button></div>
                    </div>`,
                    direction: 'right',
                  });
                }
                this.map.add(currentMaker);

                setTimeout(() => {
                  const refreshBtn = document.getElementById('refreshBtn');
                  if (refreshBtn) {
                    refreshBtn.onclick = () => {
                      mapVue.getTracksAndNodes();
                    };
                  }
                }, 500);
              }
            }
          }

          // ======路线规划======
          if (mapVue && mapVue.planLineShow && source.length && target.length) {
            // eslint-disable-next-line
            const parseRouteToPath = (route) => {
              const path = [];

              for (let i = 0, l = route.steps.length; i < l; i++) {
                const step = route.steps[i];

                for (let j = 0, n = step.path.length; j < n; j++) {
                  path.push(step.path[j]);
                }
              }

              return path;
            };
              // eslint-disable-next-line
            const drawRoute= (route) => {
              const path = parseRouteToPath(route);

              const scheduleLine = new AMap.Polyline({
                path,
                map: this.map,
                isOutline: false,
                outlineColor: '#CD5555',
                borderWeight: 4,
                strokeWeight: 6,
                strokeColor: '#5ABF7F',
                strokeStyle: 'solid',
                showDir: true,
                strokeOpacity: 0.5,
                lineJoin: 'round',
                zIndex: 99,
              });
              // 调整视野达到最佳显示区域。setFitView：地图按照适合展示图层内数据的缩放等级展示
              this.map && this.map.setFitView([scheduleLine]);
            };

            // 构造途经点
            const formatWayPoints = (points) => {
              const backPoints = [];
              points.forEach((point) => {
                backPoints.push(new AMap.LngLat(point.lng, point.lat));
              });
              return backPoints;
            };


            AMap.plugin('AMap.Driving', () => {
              // 构造路线导航类
              const drivingOption = {
                policy: AMap.DrivingPolicy.LEAST_TIME, // 规划策略
                hideMarkers: true, // 隐藏起终点
                showTraffic: false, // 是否显示实时路况
                autoFitView: false, // 地图自动定位到起终点
              };

              const driving = new AMap.Driving(drivingOption);
              // 根据起终点经纬度规划驾车导航路线
              const drivingOptions = {
                waypoints: formatWayPoints(data.nodes.points.slice(0, 16)),
              };
              driving.search(new AMap.LngLat(source[0], source[1]), new AMap.LngLat(target[0], target[1]), drivingOptions, (status, result) => {
                // result即是对应的驾车导航信息，相关数据结构文档请参考 https://lbs.amap.com/api/javascript-api/reference/route-search#m_DrivingResult
                if (status === 'complete') {
                  if (result.routes && result.routes.length) {
                    // 绘制第一条路线，也可以按需求绘制其它几条路线
                    drawRoute(result.routes[0]);
                    console.log('绘制驾车路线完成');
                  }
                } else {
                  console.log(`获取驾车数据失败：${result}`);
                }
              });
            });
          }
        } else if (name === 'mapPop') {
          // 途经点详情(数据返回结果是【维度，经度】)
          const actual = data.distance && data.distance.actual ? JSON.parse(data.distance.actual) : [];
          const plan = data.distance && data.distance.plan ? JSON.parse(data.distance.plan) : [];
          const markers = [];
          if (plan.length) {
            const planMarker = new AMap.Marker({
              position: new AMap.LngLat(plan[1], plan[0]),
              icon: new AMap.Icon({
                size: new AMap.Size(25, 34),
                image: planLocationImg,
                imageSize: new AMap.Size(25, 34),
              }),
              offset: new AMap.Pixel(-13, -30),
            });
            markers.push(planMarker);
            // 添加卡片
            planMarker.setLabel({
              offset: new AMap.Pixel(20, 20),
              content: `<div class='node-info' style='background-color:#1874CD;color:#fff;padding:5px;opacity:0.5;width:200px'>
              <div>实际地址：</div>
              <div class='card-line-content'>${data.distance.actual_text || '-'}</div>
              <br/>
              <div>目标地址：</div>
              <div class='card-line-content'>${data.distance.plan_text || '-'}</div>
              <br/>
              <div>距离偏差：</div>
              <div class='card-line-content'>${data.distance.text || '-'}</div>
              <br/>
              <div>时间偏差：</div>
              <div class='card-line-content'>${data.time.text || '-'}</div>
            </div>`,
              direction: 'right',
            });
          }
          if (actual.length) {
            const actualMarker = new AMap.Marker({
              position: new AMap.LngLat(actual[1], actual[0]),
              icon: new AMap.Icon({
                size: new AMap.Size(25, 34),
                image: actualLocationImg,
                imageSize: new AMap.Size(25, 34),
              }),
              offset: new AMap.Pixel(-13, -30),
            });
            markers.push(actualMarker);
          }
          // 添加打点
          this.map.add(markers);
          // 两点连线
          const tranceLine = new AMap.Polyline({
            path: [new AMap.LngLat(plan[1], plan[0]), new AMap.LngLat(actual[1], actual[0])],
            map: this.map,
            isOutline: false,
            borderWeight: 4,
            strokeWeight: 6,
            strokeColor: '#848484',
            strokeStyle: 'solid',
            showDir: false,
            lineJoin: 'round',
          });
          this.map && this.map.setFitView([tranceLine]);
        } else if (this.map) {
          // source && source.length && showMap(this.map, source);
          // target && target.length && showMap(this.map, target);
        }
      });
  }

  mapDestroy() {
    this.map && this.map.destroy();
  }
}

export default GMAP;
